<template>
  <provider-show-section :title="$t('MESSAGES.socialMediaLinks')">
    <div class="provider_show_social_grid">
      <component
        :is="item.value ? 'a' : 'div'"
        v-for="item in socialLinks"
        :key="item.key"
        class="provider_show_social_item"
        :class="[item.brandClass, { 'is-empty': !item.value }]"
        :href="item.value || undefined"
        :target="item.value ? '_blank' : undefined"
        rel="noopener noreferrer"
      >
        <i :class="item.icon"></i>
        <div>
          <span class="provider_show_social_label">{{ item.label }}</span>
          <span class="provider_show_social_value provider_show_value--ltr">
            {{ displayValue(item.value) }}
          </span>
        </div>
      </component>
    </div>
  </provider-show-section>
</template>

<script>
import ProviderShowSection from "./ProviderShowSection.vue";
import { buildSocialLinks, displayValue } from "@/utils/festivalProviderShow";

export default {
  name: "ProviderShowSocial",
  components: { ProviderShowSection },
  props: {
    links: { type: Object, default: () => ({}) },
  },
  computed: {
    socialLinks() {
      return buildSocialLinks(this.links, this.$t.bind(this));
    },
  },
  methods: {
    displayValue,
  },
};
</script>
